import { Tab } from 'components/create-form'
import { CreateFormModalButton } from 'components/create-form-modal'
import { Plus } from '@phosphor-icons/react'
import * as React from 'react'
import { store } from 'store/index'

type AddItemButtonProps = {
  title?: string
  activeTab?: Tab
}

export const AddItemButton: React.FC<AddItemButtonProps> = ({
  title = 'Add update',
  activeTab,
}) => {
  const { currentUser } = store
  if (!currentUser) return null

  return (
    <div className="rounded-lg border p-4 flex flex-col gap-3 relative transition-colors border-gray-100 bg-gray-50">
      <div className="w-full flex flex-col gap-4">
        <div className="mt-1 ml-1">
          <div className="rounded-full w-6 h-6 bg-theme-40 flex items-center justify-center">
            <Plus className="text-white" weight={'bold'} />
          </div>
        </div>

        <CreateFormModalButton
          title={title}
          user={currentUser}
          source={'activity_feed'}
          className="btn btn-brand btn-sm "
          label={title}
          initialTabId={activeTab}
        />
      </div>
    </div>
  )
}
